import React from "react";
import { Dialog, WithStyles, withStyles } from "@material-ui/core";
import Button from "@components/common/button/Button";
import IconButton from "@components/common/iconButton/iconButton.component";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/CloseRounded";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import ExternalCalendarEdit from "./ExternalCalendarEdit";
import { externalCalendarStyles } from "./externalCalender.style";
import TranslateNew from "@translate/TranslateNew";
import ExternalCalendarList from "./ExternalCalendarList";

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof externalCalendarStyles> {
  open: boolean;
  close: () => void;
}

interface IState {
  editCalendarId: number | "NEW" | undefined;
}

class ExternalCalendarDialog extends React.Component<IProps, IState> {
  public state: IState = { editCalendarId: undefined };

  public componentDidUpdate(prevProps: IProps) {
    if (prevProps.open && !this.props.open) {
      this.setState({ editCalendarId: undefined });
    }
  }

  public render() {
    const { classes, open, close } = this.props;
    const { editCalendarId } = this.state;
    if (editCalendarId !== undefined) {
      return <ExternalCalendarEdit open={open} close={close} editCalendarId={editCalendarId}
        onBack={this.showList} onSaved={this.showList} />;
    }
    return <Dialog open={open} onClose={close} fullWidth={true} maxWidth="sm"
      classes={{ paper: classes.paper }} aria-labelledby="external-calendars-title">
      <div className={classes.header}>
        <div className={classes.heading}>
          <h2 id="external-calendars-title" className={classes.title}>{tn.lang.externalCalImportedCalendar}</h2>
        </div>
        <IconButton onClick={close} aria-label={tn.lang.close}><CloseIcon /></IconButton>
      </div>
      <div className={classes.content}>
        <div className={classes.info}><InfoIcon /><span>{tn.lang.externalCalHowItWorks}</span></div>
        <ExternalCalendarList onCalendarSelect={(id) => this.setState({ editCalendarId: id })} />
      </div>
      <div className={`${classes.footer} ${classes.overviewFooter}`}>
        <Button className={classes.actionButton} variant="contained" color="primary" startIcon={<AddIcon />}
          onClick={() => this.setState({ editCalendarId: "NEW" })}>{tn.lang.externalCalAdd}</Button>
      </div>
    </Dialog>;
  }

  private showList = () => this.setState({ editCalendarId: undefined });
}

export default withStyles(externalCalendarStyles)(ExternalCalendarDialog);



// WEBPACK FOOTER //
// ./src/components/calendar2/externalCalendar/ExternalCalendarDialog.tsx